module.exports = __webpack_public_path__ + "img/6.076a08ba.png";